var React = require('react');

function HomeMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 8.89474L11 1L21 8.89474V22.0526H14.1579V15.7368H7.84211V22.0526H1L1 8.89474Z","stroke":"black","strokeWidth":"1.5"}));
}

HomeMobile.defaultProps = {"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none"};

module.exports = HomeMobile;

HomeMobile.default = HomeMobile;
